import React from "react";
import { FaGraduationCap, FaArrowRight } from "react-icons/fa";
import heroImg from "../../Assets/smart boy.png";

const Hero = () => {
  return (
    <section
  style={{
    position: "relative",
    overflow: "hidden",
    padding: "90px 8%",
background: `
radial-gradient(circle at 10% 20%, rgba(14,165,233,.18), transparent 28%),
radial-gradient(circle at 90% 80%, rgba(22,163,74,.14), transparent 28%),
linear-gradient(135deg,#f9fcff 0%,#eef9ff 35%,#ffffff 65%,#f5fff8 100%)
`,
  }}
    >
      {/* Decorative Circle 1 */}

<div
  style={{
    position: "absolute",
    top: "-120px",
    right: "-120px",
    width: "340px",
    height: "340px",
    borderRadius: "50%",
    background: "rgba(14,165,233,0.12)",
    filter: "blur(60px)",
    zIndex: 0,
  }}
></div>

{/* Decorative Circle 2 */}

<div
  style={{
    position: "absolute",
    bottom: "-120px",
    left: "-120px",
    width: "320px",
    height: "320px",
    borderRadius: "50%",
    background: "rgba(22,163,74,0.10)",
    filter: "blur(60px)",
    zIndex: 0,
  }}
></div>
<div
style={{
position:"absolute",
top:"45%",
left:"45%",
width:"220px",
height:"220px",
borderRadius:"50%",
background:"rgba(59,130,246,.08)",
filter:"blur(80px)",
zIndex:0
}}
/>
{/* Soft Grid */}

<div
  style={{
    position: "absolute",
    inset: 0,
    backgroundImage: `
      linear-gradient(rgba(148,163,184,.06) 1px, transparent 1px),
      linear-gradient(90deg, rgba(148,163,184,.06) 1px, transparent 1px)
    `,
    backgroundSize: "60px 60px",
    pointerEvents: "none",
    zIndex: 0,
  }}
></div>
<div
  style={{
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "50px",
  }}
>
        {/* LEFT */}

        <div style={{ flex: 1, minWidth: "350px" }}>
          <span
            style={{
              background: "#dbeafe",
              color: "#2563eb",
              padding: "8px 18px",
              borderRadius: "30px",
              fontWeight: "600",
              display: "inline-block",
              marginBottom: "20px",
            }}
          >
            Welcome to Academic Portal
          </span>

          <h1
            style={{
              fontSize: "52px",
              color: "#0f172a",
              lineHeight: "65px",
              marginBottom: "25px",
            }}
          >
            Shape Your Future With
            <br />
            Quality Education
          </h1>

          <p
            style={{
              fontSize: "18px",
              color: "#475569",
              lineHeight: "32px",
              marginBottom: "35px",
              maxWidth: "600px",
            }}
          >
            Explore admissions, placement opportunities, examination
            services, student achievements, campus events, certificates,
            employee directory and much more from one integrated
            academic portal.
          </p>

          <div
            style={{
              display: "flex",
              gap: "20px",
              flexWrap: "wrap",
            }}
          >
            <button
              style={{
                background: "#0ea5e9",
                color: "#fff",
                border: "none",
                padding: "15px 30px",
                borderRadius: "10px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              Apply Now
            </button>

            <button
              style={{
                background: "#fff",
                color: "#0ea5e9",
                border: "2px solid #0ea5e9",
                padding: "15px 30px",
                borderRadius: "10px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              Explore More <FaArrowRight />
            </button>
          </div>

          <div
            style={{
              display: "flex",
              gap: "35px",
              marginTop: "45px",
              flexWrap: "wrap",
            }}
          >
            <div>
              <h2 style={{ color: "#16a34a", margin: 0 }}>5000+</h2>
              <small>Students</small>
            </div>

            <div>
              <h2 style={{ color: "#16a34a", margin: 0 }}>150+</h2>
              <small>Faculty</small>
            </div>

            <div>
              <h2 style={{ color: "#16a34a", margin: 0 }}>98%</h2>
              <small>Placement</small>
            </div>
          </div>
        </div>

        {/* RIGHT */}

        <div
          style={{
            flex: 1,
            minWidth: "320px",
            position: "relative",
            textAlign: "center",
          }}
        >
          <img
            src={heroImg}
            alt=""
            style={{
              width: "100%",
              maxWidth: "500px",
            }}
          />

          <div
            style={{
              position: "absolute",
              top: "20px",
              left: "10px",
              background: "#fff",
              padding: "15px",
              borderRadius: "15px",
              boxShadow: "0 8px 25px rgba(0,0,0,.1)",
            }}
          >
            <FaGraduationCap
              size={35}
              color="#0ea5e9"
            />

            <h3
              style={{
                margin: "10px 0 5px",
              }}
            >
              Smart Learning
            </h3>

            <small>
              Learn with modern education system.
            </small>
          </div>

          <div
            style={{
              position: "absolute",
              bottom: "30px",
              right: "0",
              background: "#fff",
              padding: "18px",
              borderRadius: "15px",
              boxShadow: "0 8px 25px rgba(0,0,0,.1)",
            }}
          >
            <h2
              style={{
                color: "#16a34a",
                margin: 0,
              }}
            >
              100+
            </h2>

            <small>Recruiting Companies</small>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;